import { getRoute, useView } from '@/functions';

export default {
    path: '/',
    component: useView('login/login_sites_page'),
    children: [
        getRoute('/login-sites', 'loginSites', 'login/login_sites_page', { title: 'Accounts Sites Login' }),
    ]
}